import { Denuncia } from '../Denuncias/Denuncia';

export const Denuncias = () => {
  return (
    <>
      <Denuncia />
    </>
  );
};
